import axios from "axios";
import { API } from "../shared/config";
import { meilleurePosition } from "./meilleurePosition";

export const ACTIONS_POINTAGE = ['arrivee', 'debut_pause', 'fin_pause', 'depart'];
export const MSG_POINTAGE = { arrivee: 'Arrivée enregistrée', debut_pause: 'Début de pause', fin_pause: 'Fin de pause', depart: 'Départ enregistré' };

export const prochaineAction = (p = {}) => {
  if (!p.arrivee) return 'arrivee';
  if (!p.debut_pause && !p.depart) return 'debut_pause';
  if (p.debut_pause && !p.fin_pause && !p.depart) return 'fin_pause';
  if (!p.depart) return 'depart';
  return null;
};

// Wi-Fi du cabinet prioritaire : 1er envoi sans GPS ; si le serveur demande la position, on cherche la meilleure puis on renvoie.
// Rejette l'erreur axios (422 POINTAGE_HORS_ZONE inclus) pour que l'appelant affiche la confirmation hors zone.
export const pointer = async (action, { force, motif, onLocalisation } = {}) => {
  const envoyer = (coords) => {
    const payload = { action };
    if (coords?.lat != null) { payload.geo_lat = coords.lat; payload.geo_lng = coords.lng; payload.geo_accuracy = coords.accuracy; }
    if (coords?.erreur) payload.geo_erreur = coords.erreur;
    if (force) payload.force = true;
    if (motif) payload.motif = motif;
    return axios.post(`${API}/pointage/action`, payload).then(r => r.data);
  };
  try {
    return await envoyer(null);
  } catch (err) {
    const d = err.response?.data?.detail;
    if (force || !(err.response?.status === 422 && d?.code === 'POINTAGE_HORS_ZONE' && d.zone_info?.gps_requis)) throw err;
    onLocalisation?.(true);
    try { return await envoyer(await meilleurePosition()); } finally { onLocalisation?.(false); }
  }
};

export const horsZone = (err) => {
  const d = err?.response?.data?.detail;
  return err?.response?.status === 422 && d?.code === 'POINTAGE_HORS_ZONE' ? d : null;
};

// Déconnexion : laisse le rappel de pointage intercepter si besoin.
export const demanderDeconnexion = (logout) => {
  if (typeof window.__ophtaAvantDeconnexion === 'function') window.__ophtaAvantDeconnexion(logout);
  else logout();
};
